import { posthogEvents } from '@/shared/constants/constants';

type TrackingProduct = {
  product_id: string | number;
  product_name: string | undefined;
  product_category: string | undefined;
  variant: string | undefined;
  quantity: number | undefined;
  price: number;
};

export const trackPatternProductsAddAllToCart = (
  productsAndQuantities: TrackingProduct[],
  scope: string
) => {
  window.posthog?.capture('what_youll_need_add_all_to_cart', {
    products_and_quantities: productsAndQuantities,
    scope: scope,
    total_items: productsAndQuantities.length,
    total_value: productsAndQuantities.reduce(
      (sum: number, item: TrackingProduct) =>
        sum + item.price * (item.quantity || 0),
      0
    ),
    currency: window.Shopify.currency.active
  });
};

export const trackPatternProductAddToCart = (item: TrackingProduct) => {
  window.posthog?.capture(posthogEvents.PATTERN_PRODUCTS_ADD_TO_CART, {
    ...item,
    total_value: item.price * (item.quantity || 0),
    currency: window.Shopify.currency.active
  });
};
